import { render, staticRenderFns } from "./MerchantDropoffFail.vue?vue&type=template&id=6e07b9d6&scoped=true&"
import script from "./MerchantDropoffFail.vue?vue&type=script&lang=js&"
export * from "./MerchantDropoffFail.vue?vue&type=script&lang=js&"
import style0 from "./MerchantDropoffFail.vue?vue&type=style&index=0&id=6e07b9d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e07b9d6",
  null
  
)

export default component.exports